import styled from "styled-components";
import {
  FixedBar as FixedBarElement,
  Button as ButtonElement,
} from "react-ui-kit";
import HeaderElement from "./Header";
import FooterElement from "./Footer";
// import FAQElement from "./FAQ";
// import { TContentProps } from "../@types/ComponentProps/TTemplateComponentProps";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const Header = styled(HeaderElement);
export const Footer = styled(FooterElement)``;
// export const Content = styled.div<TContentProps>`
export const Content = styled.div`
  flex-grow: 0;
  flex-shrink: 0;
  flex-basis: calc(100% - 344px);
`;

// export const FAQ = styled(FAQElement)``;

export const SteperContainer = styled.div`
  background-color: #fff;
  width: 100%;
  height: 200px;
  padding-top: 5px;
  border-bottom: 1px solid #ddd;
  display: flex;
  align-items: center;
  #steper > div {
    height: 40px !important;
  }
`;

export const FixedBar = styled(FixedBarElement)``;
export const Button = styled(ButtonElement)``;
